import I18n from 'I18n';
import * as ActionTypes from '../actions/ActionTypes';
const INITIAL_STATE = {};
export default function templatePreviewPlaceholders(state = INITIAL_STATE, {
  type
}) {
  switch (type) {
    case ActionTypes.APP_STARTED:
      return {
        categoryDescription: I18n.text('knowledgeContentUI.templateEditor.sidebar.homepageCategory.categoryDescriptionPlaceholder'),
        welcomeMessage: I18n.text('knowledgeContentUI.templateEditor.fields.welcomeMessage.placeholder')
      };
    default:
      return state;
  }
}